import Service from '../AuthService';

const Gender = {
  getAllGenders() {
    return Service.get(`genders`);
  }
};

export default Gender;
